import { Suspense, lazy, useEffect, useState } from 'react'
import { NavLink, Navigate, Route, Routes } from 'react-router-dom'
import { api } from './api'
import Login from './pages/Login'
import Today from './pages/Today'

// The daily entry screen is the hot path and is used far more than the other
// two. Charts pull in Recharts and Export pulls in the xlsx writer, so both are
// split out rather than loaded on every visit.
const Charts = lazy(() => import('./pages/Charts'))
const ExportPage = lazy(() => import('./pages/ExportPage'))

export default function App() {
  const [authed, setAuthed] = useState<boolean | null>(null)

  useEffect(() => {
    api
      .session()
      .then((s) => setAuthed(s.authenticated))
      .catch(() => setAuthed(false))
  }, [])

  if (authed === null) return <div className="empty-state">Loading…</div>
  if (!authed) return <Login onSuccess={() => setAuthed(true)} />

  return (
    <div className="app">
      <Suspense fallback={<div className="empty-state">Loading…</div>}>
        <Routes>
          <Route path="/" element={<Today />} />
          <Route path="/charts" element={<Charts />} />
          <Route path="/export" element={<ExportPage onLogout={() => setAuthed(false)} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
      <nav className="tabbar">
        <NavLink to="/" end>
          <span className="glyph">✎</span>Today
        </NavLink>
        <NavLink to="/charts">
          <span className="glyph">📈</span>Charts
        </NavLink>
        <NavLink to="/export">
          <span className="glyph">⬇</span>Export
        </NavLink>
      </nav>
    </div>
  )
}
